<template>
    <div class="pro-item">
        <div class="title">所有{{editName}}设置会员折扣</div>
        <div class="list-box">
            <el-table :data="allProDisData.listData"
                      style="width: 100%">
                <el-table-column
                        v-for="(val, k) in allProDisData.fields"
                        :prop="val.field"
                        :label="val.label"
                        >
                </el-table-column>

                <el-table-column label="操作" v-if="isMain||!isUnified">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <edit-product-category-discount v-model="editBoxState" :pro-type="proType" :pro-data="editProData"
                                        @done="loadAllProDisData"
        ></edit-product-category-discount>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import EditProductCategoryDiscount from "@/model/StoreUser/EditProductCategoryDiscount";
    export default {
        name: "ProductAllDiscount",
        components: {EditProductCategoryDiscount},
        props: {
            proType: {
                type: Number,
                default: 0
            }
        },
        data: () => ({
            allProDisData: {
                fields: [
                    // {
                    //     label: "类别",
                    //     field: "name"
                    // }
                ],
                listData: [
                    // {
                    //     name: "所有",
                    // }
                ]
            },
            editBoxState: false,
            editProData: {
                id: 0,
                type: 1,     //折扣类型：1 所有，2 分类， 3 项目|商品
                title: "所有",
            },
            editName: ""
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            },
            isUnified(){
                return this.$store.state.chain_option.is_unified_manage;
            }
        },
        mounted: function () {
            this.initData();
        },
        methods: {
            initData: function () {
                if(this.proType === 1) {
                    this.editName = "项目";
                }else if(this.proType === 2) {
                    this.editName = "产品";
                }else if(this.proType === 5) {
                    this.editName = "卡项";
                }else{
                    this.editName = "";
                    return false;
                }
                this.loadAllProDisData();
            },
            loadAllProDisData: function () {
                obj.postData("store_vip/get_vip_all_discount", {pro_type: this.proType}, res => {
                    let disData = {
                        fields: [
                            {
                                label: "类别",
                                field: "name"
                            }
                        ], listData: [
                            {
                                name: "所有"
                            }
                        ]
                    };
                    res.data.forEach((val, k) => {
                        disData.fields.push({
                            label: val.vip_name,
                            field: "vip_"+val.vip_id
                        });
                        let unit = val.discount_mode == 1 ? "折" : "元";
                        disData.listData[0]["vip_"+val.vip_id] = val.discount_data + unit;
                    });
                    this.allProDisData = disData;
                });
            },
            handleEdit: function (index, data) {
                this.editBoxState = true;
            }
        },
        watch: {
            proType: function (val) {
                this.initData();
            }
        }
    }
</script>

<style scoped>
    .pro-item>.title{
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        height: 16px;
        line-height: 16px;
        padding: 10px;
        min-width: 800px;
        overflow: hidden;
    }
    .pro-item>.title:before{
        width: 4px;
        height: 16px;
        background-color: #0f9cf3;
        border-radius: 2px;
        content: "";
        display: inline-block;
        margin-right: 10px;
        vertical-align: text-top;
    }
    .text-btn {
        font-size: 14px;
        color: #6cb1e1;
        margin-left: 10px;
        cursor: pointer;
    }
</style>
